import { Button } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import SuccessContent from './SuccessContent';
const Success = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const isApiPlan = queryParams.get('planType') === 'api';
  const redirectUserToApp = () => {
    window.top.location.href = process.env.REACT_APP_PICTORY_APP_URL;
  };

  if (isApiPlan) return <SuccessContent redirectUserToApp={redirectUserToApp} />;
  return (
    <div style={{ textAlign: 'center', marginTop: '50vh', transform: 'translateY(-50%)', height: '45vh' }}>
      <h1 style={{ color: '#6f47cb' }}>Achievement Unlocked ! 🔓 </h1>
      <h2>
        {isApiPlan
          ? "You're just one step away from hitting your first API endpoint!!!"
          : "You're just one step away from your First video !!!"}
      </h2>
      <p>If you're new to Pictory, we've just sent you reset password link on your email.</p>
      {isApiPlan && <p>Once you're in, head over to the "My Account" section to find your API keys.</p>}
      <Button
        variant="outlined"
        onClick={redirectUserToApp}
        sx={{
          color: '#6f47cb',
          borderColor: '#6f47cb',
          fontWeight: 'bold',
          '&:hover': {
            borderColor: '#6f47cb',
            backgroundColor: 'rgba(111, 71, 203, 0.1)', // optional: subtle hover background
          },
        }}
      >
        Login Now
      </Button>
    </div>
  );
};

export default Success;
